import { attributeChanged, define } from '@directive'
import Echo from '@echo'
import { customEvent } from '@event'
import { around } from '@middleware'
import { Headless } from '@mixin'
import { dispatch } from './interfaces'

@define('kb-find')
class Find extends Echo(Headless(HTMLElement)) {
  #key
  #value

  get key() {
    return this.#key
  }

  @attributeChanged('key')
  set key(value) {
    this.#key = value
  }

  get value() {
    return this.#value
  }

  @attributeChanged('value')
  @around(dispatch)
  set value(value) {
    this.#value = value
  }

  // Waits for the parent custom element to upgrade before reading its `value`, since
  // finding relies on the parent already exposing a records collection (e.g. kb-dataset).
  async [dispatch]() {
    await customElements.whenDefined(this.parentElement?.localName)
    const detail = this.parentElement.value.find(
      ({ [this.key]: value }) => value === this.value,
    )
    this.parentElement.dispatchEvent(customEvent('found', detail))
    return this
  }
}

export default Find
